import { render, staticRenderFns } from "./MyBenefits.vue?vue&type=template&id=28f0a942&scoped=true&"
import script from "./MyBenefits.vue?vue&type=script&lang=js&"
export * from "./MyBenefits.vue?vue&type=script&lang=js&"
import style0 from "./MyBenefits.vue?vue&type=style&index=0&id=28f0a942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0a942",
  null
  
)

export default component.exports